import { AIConversationType } from '@ViewModels';
import { AdminPermission } from '../../../viewmodels/AdminViewModels';

// Sales conversation types are managed in AIDA and hidden from admin
export const conversationTypes = [
	{ value: AIConversationType.BlogGeneration, label: 'Blog' },
	{ value: AIConversationType.EmailContentGeneration, label: 'Email Content' },
	{ value: AIConversationType.GoogleReviewReply, label: 'Google Review Reply' },
	{ value: AIConversationType.SiteWide, label: 'Site Wide' },
	{ value: AIConversationType.SocialMediaContentGeneration, label: 'Social Media Content Generation' },
	{ value: AIConversationType.SuccessMeetingPrep, label: 'Success Meeting Prep' },
];

// Categorize conversation types by required permissions
export const conversationTypePermissions: Partial<Record<AIConversationType, AdminPermission>> = {
	[AIConversationType.SalesPracticeCall]: AdminPermission.ModifySalesPrompts,
	[AIConversationType.SalesPostCallCoaching]: AdminPermission.ModifySalesPrompts,
	[AIConversationType.SalesPreCallCoaching]: AdminPermission.ModifySalesPrompts,
	[AIConversationType.SalesDemoCallCoaching]: AdminPermission.ModifySalesPrompts,
	[AIConversationType.SuccessMeetingPrep]: AdminPermission.ModifySystemPrompts,
	[AIConversationType.BlogGeneration]: AdminPermission.ModifyContentGenerationPrompts,
	[AIConversationType.EmailContentGeneration]: AdminPermission.ModifyContentGenerationPrompts,
	[AIConversationType.SocialMediaContentGeneration]: AdminPermission.ModifyContentGenerationPrompts,
	[AIConversationType.GoogleReviewReply]: AdminPermission.ModifySystemPrompts,
	[AIConversationType.SiteWide]: AdminPermission.ModifySystemPrompts,
};

export function getFilteredConversationTypes(userPermissions: Record<AdminPermission, boolean>) {
	return conversationTypes.filter(conversationType => {
		const requiredPermission = conversationTypePermissions[conversationType.value];
		return userPermissions[requiredPermission] === true;
	});
}

export const availableModels = [
	// GPT-4 Family
	{ value: 'gpt-4', label: 'GPT-4' },
	{ value: 'gpt-4-turbo', label: 'GPT-4 Turbo' },
	{ value: 'gpt-4-turbo-preview', label: 'GPT-4 Turbo Preview' },
	{ value: 'gpt-4o', label: 'GPT-4o' },
	{ value: 'gpt-4o-mini', label: 'GPT-4o Mini' },

	// GPT-4.1 Family
	{ value: 'gpt-4.1', label: 'GPT-4.1' },
	{ value: 'gpt-4.1-mini', label: 'GPT-4.1 Mini' },
	{ value: 'gpt-4.1-nano', label: 'GPT-4.1 Nano' },

	// GPT-5 Family
	{ value: 'gpt-5', label: 'GPT-5' },
	{ value: 'gpt-5-mini', label: 'GPT-5 Mini' },
	{ value: 'gpt-5-nano', label: 'GPT-5 Nano' },

	// O3 Mini
	{ value: 'o3-mini', label: 'O3 Mini' },

	// GPT-4 Realtime Models
	{ value: 'gpt-4o-realtime-preview', label: 'GPT-4o Realtime Preview' },
];

export const verticalOptions = [
	{ value: 'Accounting', label: 'Accounting' },
	{ value: 'Financial', label: 'Financial' },
	{ value: 'Home Maintenance', label: 'Home Maintenance' },
	{ value: 'Insurance', label: 'Insurance' },
	{ value: 'Legal', label: 'Legal' },
	{ value: 'Non-Profit', label: 'Non-Profit' },
];
